import { render, staticRenderFns } from "./CommentLoader.vue?vue&type=template&id=28bfc1a0&scoped=true"
import script from "./CommentLoader.vue?vue&type=script&lang=ts"
export * from "./CommentLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bfc1a0",
  null
  
)

export default component.exports